import {dataTestId} from '@hconnect/uikit/src/common/utils/testingUtils'
import {DeleteOutline} from '@mui/icons-material'
import {Button} from '@mui/material'
import {usePlanningChartStartEnd} from '@widgets/planning-schedule-chart'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../../../consts'
import {useDialog} from '../../../../providers'
import {AutofillRemovalDialogContent} from '../autofillRemoval'

export const RemoveAutofillItemsButton: React.FC = () => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const {openDialog} = useDialog()
  const {
    boundary: [, endOfPlanning]
  } = usePlanningChartStartEnd()

  const openSelectRangeDialog = () => {
    openDialog({
      header: {
        title: t('planning.removeAutofillItems')
      },
      content: <AutofillRemovalDialogContent endOfPlanning={endOfPlanning} />
    })
  }

  return (
    <Button
      variant="text"
      color="error"
      onClick={openSelectRangeDialog}
      {...dataTestId('open_remove_autofill_items_dialog_btn')}
    >
      <DeleteOutline sx={{mr: 0.5}} /> {t('common.remove')}
    </Button>
  )
}
